'use strict'

export function searchJsonFilter() {
  return function (items, searchTerm, properties) {
    // If no phrase is defined, return no items
    if (!searchTerm) return []
    let filtered = []

    // Construct regex, logical OR operator between all partial strings
    const regexes = searchTerm.split(' ').map((reg) => new RegExp(reg, 'i'))

    // Properties to be matched. If no argument is present, get all properties which are strings.
    const props = properties || Object.keys(items[0]).filter((p) => typeof items[0][p] === 'string')

    items.forEach((item) => {
      // Matches indicates the regex matches within one item
      let matches = 0

      // Go through all strings of the search term
      for (let regex of regexes) {
        // Go through all properties which should be included
        for (let prop of props) {
          if (item[prop] && regex.test(item[prop])) {
            // Count up matches if regex matches with the property value
            matches++

            // Escape the loop, so a regex won't get counted twice
            break
          }
        }

        if (matches >= regexes.length) {
          // If all regex options had a successful match after the iteration, push the item to the result
          filtered.push(item)

          // Reset counter
          matches = 0

          // Break to avoid that a item gets pushed twice
          break
        }
      }
    })

    return filtered
  }
}



// WEBPACK FOOTER //
// ./app/shared/filters/search-json.filter.js